import type { Social } from '.';
import { encodePacket } from '../utils/encoder';
import {
  inviteRewardEnergy,
  inviteRewardGems,
  inviteShareGemsReward,
  inviteShareGemsRewardSuccess,
  inviteShareGemsRewardSuccessCap,
  SocialSubFeature,
} from './social.ruleset';
import { Inventory } from '../buruburu/inventory';

export const socialGetters = (
  Social: Social,
  { Tutorial, Minigame }: Social['$DEPENDENCIES'],
) => (state: Social.State) => ({
  hasMetUnlockCriteria: () =>
    Minigame.getters(state).getMinigameCount() >=
    Social.ruleset.minigamesToUnlockInvite,

  isFriendInviteAvailable: () => {
    return false;
    /*
    const { isTutorialStepComplete } = Tutorial.getters(state);
    if (isTutorialStepComplete('friendReferral')) {
      // Feature already unlocked
      return true;
    }

    const {
      minigamesToUnlockInvite: requiredMinigames,
      coinsLessThanToUnlockInvite: pointsThreshold,
    } = Social.ruleset;
    if (Minigame.getters(state).getMinigameCount() >= requiredMinigames) {
      // Player meets unlock requirements
      return true;
    }

    return false;
    return socialGetters(
      Social,
      Social.$DEPENDENCIES,
    )(state).hasMetUnlockCriteria();
    */
  },

  getExcludedFriendsForInvite: (friendIds: string[], now: number) =>
    friendIds.filter((id) => {
      const maskedId = encodePacket(id);
      const invite = state.social.invites[maskedId];
      return invite?.timeSent > now - Social.ruleset.recentInviteDuration;
    }),

  getInviteReward: (subFeature: SocialSubFeature) => {
    switch (subFeature) {
      case 'invite_no_energy':
        return { value: inviteRewardEnergy, type: 'energy' as const };
      case 'invite_share_gems_reward':
        return { value: inviteShareGemsReward, type: 'gems' as const };
      case 'invite_share_gems_reward_success':
        return { value: inviteShareGemsRewardSuccess, type: 'gems' as const };
      default:
        return { value: inviteRewardGems, type: 'gems' as const };
    }
  },

  /** Retrieve the maximum amount of currency that can be claimed at once, if there is one */
  getInviteRewardCap: (subFeature: SocialSubFeature) => {
    if (subFeature === 'invite_share_gems_reward_success') {
      return {
        value: inviteShareGemsRewardSuccessCap,
        type: 'gems' as const,
      };
    }
    // No cap for other invite rewards
    return null;
  },

  getInviteLimit: (subFeature: SocialSubFeature, now: number) => {
    let limit = Social.ruleset.inviteFriendListSelectionLimit;
    if (subFeature === 'invite_no_energy') {
      const { maxRewardedEnergy } = Inventory.ruleset;
      const currentEnergy = Inventory.getters(state).getEnergy(now);
      limit = Math.min(limit, maxRewardedEnergy - currentEnergy);
    }

    // Ensure we don't declare a negative limit
    return Math.max(limit, 0);
  },

  /** Get the number of unclaimed referral rewards available */
  getUnclaimedReferralRewardCount: () => {
    const unclaimed = Object.values(state.social.invites).filter(
      (invite) => invite.referralRewardClaimed === false,
    );
    return unclaimed.length;
  },
});
